<template>
    <div class="globe-foot-bar">
        <div v-if="isMobile" class="mobile-left-side">
            <download-pdf-button class="download-pdf-button"/>
            <risk-key class="risk-key-component"/>
        </div>
        <download-pdf-button v-if="!isMobile" class="download-pdf-button"/>
        <risk-key v-if="!isMobile" class="risk-key-component" />
        <zoom-buttons v-if="!isMobile" @zoom="handleZoom" class="zoom-buttons-component" />
    </div>
</template>

<script>
export default {
    name: 'GlobeFootBar',
    data() {
        return {
            isMobile: window.innerWidth <= 900
        };
    },
    created() {
        window.addEventListener('resize', this.handleResize);
        this.handleResize();
    },
    beforeUnmount() {
        window.removeEventListener('resize', this.handleResize);
    },
    methods: {
        handleZoom(zoomFactor) {
            this.$emit('zoom', zoomFactor);
        },
        handleResize() {
            this.isMobile = window.innerWidth <= 1025;
        }
    }
}
</script>

<style scoped>
.globe-foot-bar {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
}

.mobile-left-side {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: calc((2 * 30px) + (8px));
  margin-left: 5%;
  bottom: 2%;
}

.download-pdf-button {
    margin-left: 48px;
}

.zoom-buttons-component {
  margin-right: 48px;
}

.risk-key-component {
  bottom: 2%;
}

@media (max-width: 900px) {
    .download-pdf-button {
        margin-left: 0;
    }
}
</style>